<script setup>
  import { ref } from 'vue';
  import ExploremoreLcCat from './exploremore-lc-cat.vue'
  import "@/styles/css/learning-center.scss";
  const view = ref(false)
  const openView = () => {
    view.value = true
  }
</script>
<template>
  <div class="container-learning-center page-container" style="margin-top: 70px;">
    <section class="lc_completeToc">
      <section class="learning-center_banner">
        <div class="visible-lg visible-md visible-sm">
          <picture>
            <source srcset="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-intraday-trading.webp"
              type="image/webp">
            <img title="Intraday Trading" alt="intraday trading"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-intraday-trading.png">
          </picture>
        </div>
        <div class="visible-xs">
          <picture>
            <source
              srcset="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-intraday-trading-mobile.webp"
              type="image/webp">
            <img alt="intraday trading"
              src="https://upstox.com/app/themes/upstox/dist/img/learning_center/Banner-intraday-trading-mobile.png">
          </picture>

        </div>
      </section>

      <section class="toc_container LC-article">
        <div class="container-fluid ht-page faq">
          <div class="">
            <div class="lc-cat-toc-wraper">
              <h1 class="curr-tax">Intraday Trading</h1><br>
              <p class="curr-tax-desc">A complete guide to the world of intraday trading and day traders. </p>
            </div>
            <div class="lc-cat-toc-wraper">
              <p class="toc-txt">TABLE OF CONTENTS</p>
              <ul class="lc-category-page-wrapper hidden-md hidden-lg">

                <li class="LC-toc-list">
                  <h2>
                    <a id="1"
                      href="/learning-center/intraday-trading/how-are-gains-from-intraday-trading-taxed-for-itr/">How
                      are Gains from Intraday Trading Taxed for ITR</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="2" href="/learning-center/intraday-trading/what-is-a-cover-order/">What is a
                      Cover Order?</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="3" href="/learning-center/intraday-trading/basics-of-investing-in-intraday-trading/">Basics
                      of investing in intraday trading</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="4" href="/learning-center/intraday-trading/risk-management-in-intraday-trading/">Risk
                      management in intraday trading</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="5" href="/learning-center/intraday-trading/what-is-day-trading/">What is Day
                      Trading?</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="6"
                      href="/learning-center/intraday-trading/difference-between-intraday-and-delivery-trading/">Difference
                      between intraday and delivery trading</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="7" href="/learning-center/intraday-trading/how-to-do-intraday-trading/">How
                      To Do &amp; Start Intraday Trading For Beginners</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="8" href="/learning-center/intraday-trading/what-is-intraday-trading/">What is
                      Intraday Trading for Beginners - Strategies, Indicators &amp; Meaning</a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="9" href="/learning-center/intraday-trading/intraday-trading-tips-and-tricks/">Best
                      Intraday Trading Tips and Tricks For Beginners in India</a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="10" href="/learning-center/intraday-trading/how-to-choose-stocks-for-intraday-trading/">How
                      to choose stocks for intraday trading?</a>
                  </h2>
                </li>
                <!-- <div id="showall-posts">Show All</div>
              <div class="scroll-down" id="scroll-d">
                <img alt="Scroll Down" src="https://upstox.com/app/themes/upstox/dist/img/learning_center/scroll.png">
              </div> -->
              </ul>
              <ul class="lc-category-page-wrapper hidden-xs hidden-sm">

                <li class="LC-toc-list">
                  <h2>
                    <a id="1"
                      href="/learning-center/intraday-trading/how-are-gains-from-intraday-trading-taxed-for-itr/">
                      How are Gains from Intraday Trading Taxed for ITR </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="2" href="/learning-center/intraday-trading/what-is-a-cover-order/">
                      What is a Cover Order? </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="3" href="/learning-center/intraday-trading/basics-of-investing-in-intraday-trading/">
                      Basics of investing in intraday trading </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="4" href="/learning-center/intraday-trading/risk-management-in-intraday-trading/">
                      Risk management in intraday trading </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="5" href="/learning-center/intraday-trading/what-is-day-trading/">
                      What is Day Trading? </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="6"
                      href="/learning-center/intraday-trading/difference-between-intraday-and-delivery-trading/">
                      Difference between intraday and delivery trading </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="7" href="/learning-center/intraday-trading/how-to-do-intraday-trading/">
                      How To Do &amp; Start Intraday Trading For Beginners </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="8" href="/learning-center/intraday-trading/what-is-intraday-trading/">
                      What is Intraday Trading for Beginners - Strategies, Indicators &amp; Meaning </a>
                  </h2>
                </li>
                <li class="LC-toc-list">
                  <h2>
                    <a id="9" href="/learning-center/intraday-trading/intraday-trading-tips-and-tricks/">
                      Best Intraday Trading Tips and Tricks For Beginners in India </a>
                  </h2>
                </li>
                <li class="LC-toc-list hide">
                  <h2>
                    <a id="10" href="/learning-center/intraday-trading/how-to-choose-stocks-for-intraday-trading/">
                      How to choose stocks for intraday trading? </a>
                  </h2>
                </li>
                <!-- <div id="showall-posts">Show All</div> -->
              </ul>
            </div>
          </div>
          <div class="lc-toc-container">
          </div>
        </div>
      </section>
      <div id="showall-article" class="showall-article hidden-md hidden-lg">
        Table of contents
      </div>
    </section>
    <exploremoreLcCat></exploremoreLcCat>
  </div>
</template>
<style scoped>
</style>